<template>
  <div>
    <shop-head currentPageName="qpjnh"></shop-head>
    <!-- 面包屑 -->
    <!-- 主要内容 -->
    <div class="content_wrapper">
      <div class="container">
        <!-- <breadcrumb pageName="汽配嘉年华"></breadcrumb> -->
        <el-row :gutter="0">
          <el-col :span="24" :offset="0">
            <div class="head">
              <img
                v-if="activelist[0].image"
                :src="activelist[0].image"
                style="
                  width: 100%;
                  /* height: 490px; */
                  object-fit: fill;
                  position: absolute;
                  top: 0;
                "
              />
              <img src="#" alt="" style="width: 100%; height: 611px" />
              <div class="head-enter">
                <div @click="goto('subapply')">
                  <i class="el-icon-s-custom"></i>{{ $t("展商入口") }} >
                </div>
                <div @click="goto('booking')" style="background-color: #16a753">
                  <i class="el-icon-user"> </i> {{ $t("观众入口") }} >
                </div>
                <div style="background-color: #f4f4f4"></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <video
              controls
              src="https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh1fbe7795cfc74c4b9e58ae06eb07c6d5%E5%B9%BF%E5%9B%AD%E6%B1%87.mp4"
              width="500px"
              height="240px"
            ></video>
          </el-col>
          <el-col :span="12" :offset="0">
            <h1 style="color: #1b2d71; font-weight: 600">
              {{ $t("展会概况") }}
            </h1>
            <p>
              {{ activelist[0].content }}
            </p>
            <el-button
              v-if="!detailsVisable"
              type=""
              size="default"
              @click="detailsVisable = true"
            >
              {{ $t("查看详情") }}></el-button
            >
            <div v-if="detailsVisable">
              <span
                >{{ $t("参加人数") }}:
                {{ activelist[0].bookingNum || 100 }}人</span
              >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >{{ $t("活动时间") }}:
                {{ activelist[0].startTime | formatDate }} ~
                {{ activelist[0].endTime | formatDate }}</span
              >
            </div>
          </el-col>
        </el-row>
        <br />
        <h1>{{ $t("活动介绍") }}</h1>
        <br />
        <p>
          {{ activelist[0].content }}
        </p>
        <br />
        <h1>{{ $t("活动介绍") }}</h1>
        <img
          style="width: 100%"
          src="../../assets/images/高铁to展馆.png"
          alt=""
        />
        <br />
        <br />
        <div class="banner">
          <h1 style="color: #1b2d71; font-weight: 600">{{ $t("展会新闻") }}</h1>
          <p class="more" @click="handleSearch(4)">
            <i
              class="el-icon-arrow-right"
              style="
                color: #fff;
                background-color: #adadad;
                border-radius: 10px;
                padding: 2px;
              "
            ></i>
            {{ $t("更多") }}
          </p>
          <br />
          <el-row :gutter="50">
            <el-col :span="12" :offset="0">
              <div class="frist-banner">
                <el-row>
                  <el-col :span="12" :offset="0">
                    <img
                      :src="activelist[0].image"
                      style="width: 260px; height: 120px"
                      alt=""
                    />
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <h3>{{ activelist[0].name }}</h3>
                    <p class="activeContent" :title="activelist[0].content">
                      {{ activelist[0].content }}
                    </p>
                    <p>
                      <i class="el-icon-time"></i
                      >{{ activelist[0].startTime | formatDate }}
                    </p>
                  </el-col>
                </el-row>
              </div>
              <br />
              <div
                v-for="item in activelist.slice(1)"
                :key="item.image"
                style="
                  border-left: #9ec1ed solid 3px;
                  margin-bottom: 10px;
                  padding: 16px 10px;
                  background-color: #fff;
                "
              >
                {{ item.name }}
                <span style="float: right"
                  ><i class="el-icon-time"></i
                  >{{ item.startTime | formatDate }}</span
                >
              </div>
            </el-col>
            <el-col :span="12" :offset="0">
              <div class="frist-banner">
                <el-row>
                  <el-col :span="12" :offset="0">
                    <img
                      :src="activelist[0].image"
                      style="width: 260px; height: 120px"
                      alt=""
                    />
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <h3>{{ activelist[0].name }}</h3>
                    <p class="activeContent" :title="activelist[0].content">
                      {{ activelist[0].content }}
                    </p>
                    <p>
                      <i class="el-icon-time"></i
                      >{{ activelist[0].startTime | formatDate }}
                    </p>
                  </el-col>
                </el-row>
              </div>
              <br />
              <div
                v-for="item in activelist.slice(1)"
                :key="item.id"
                style="
                  border-left: #9ec1ed solid 3px;
                  margin-bottom: 10px;
                  padding: 16px 10px;
                  background-color: #fff;
                "
              >
                {{ item.name }}
                <span style="float: right"
                  ><i class="el-icon-time"></i
                  >{{ item.startTime | formatDate }}</span
                >
              </div>
            </el-col>
          </el-row>
          <Editor style="height: 0px; width: 0px" @onCreated="onCreated" />
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { activelist } from "../../apis/qpjnh";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
    Editor,
    Toolbar,
  },
  filters: {
    formatDate(time) {
      return time ? new Date(time).toLocaleString().replaceAll("/", "-") : "--";
    },
  },
  data() {
    return {
      editor: null,
      detailsVisable: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      search: {
        status: 2,
        currentPage: 1,
        pageSize: 4,
      },
      activelist: [{}],
    };
  },
  watch: {
    showDetail(val) {},
  },
  created() {
    this.getList();
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    async getList() {
      var { list, total } = (await activelist(this.search)).data;
      if (list.length < 1) {
        this.search.status = 3;
        let data = (await activelist(this.search)).data;
        list = data.list;
        total = data.list;
      }
      list.map((item) => {
        this.editor.setHtml(item.content || "<p><br></p>");
        item.content = this.editor.getText();
      });
      this.activelist = list;
      this.total = total;
    },
    goto(name) {
      this.$router.push({ name });
      // window.scrollTo(0, 1000)
    },
    // 查询数据
    handleSearch() {
      if (this.total <= this.activelist.length) {
        this.$message(this.$i18n.t("没有更多了") + "~");
        return;
      }
      this.search.pageSize = this.search.pageSize + 4;
      // this.$router.replace({
      //   path: this.$route.path,
      //   query: {
      //     ...this.search
      //   },
      // });
      this.getList({ ...this.search });
    },
    /** 跳转详情 */
    gotoDetail(id) {
      this.$router.push({
        path: "/shopDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;

  > h1 {
    color: #1b2d71;
    font-weight: 600;
    border-bottom: #1b2d71 5px solid;
  }

  .head {
    .head-enter {
      position: absolute;
      bottom: 0px;
      left: 0;
      display: flex;
      padding: 15px;
      width: 100%;
      justify-content: space-between;
      background-color: #f4f4f4;
      div {
        color: #fff;
        line-height: 90px;
        text-align: center;
        cursor: pointer;
        font-size: 20px;
        width: 290px;
        height: 90px;
        background-color: #0f6ab3;
        // border: 1px solid red;
        i {
          font-size: 38px;
          vertical-align: sub;
          margin-top: 10px;
          margin-right: 20px;
        }
      }
    }
  }

  .banner {
    background-color: #f4f4f4;
    padding: 10px 20px;
    position: relative;

    .activeContent {
      display: -webkit-box;
      /* 使文本成为弹性盒子模型 */
      -webkit-line-clamp: 3;
      /* 设置显示的行数（例如 3 行） */
      -webkit-box-orient: vertical;
      /* 设置为纵向排列 */
      overflow: hidden;
      /* 隐藏超出部分 */
      text-overflow: ellipsis;
      /* 添加省略号 */
      white-space: normal;
    }

    .more {
      position: absolute;
      cursor: pointer;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>